/**
 * The onboarding chart's window: the 6 / 9 month pills, and how they combine with the report's
 * date filter. A date range the user picked always wins, so the pills only apply without one.
 * Kept out of the component so it can be tested with node:test (which cannot import JSX).
 */
export const TREND_WINDOW_OPTIONS = [6, 9];
export const DEFAULT_TREND_MONTHS = 6;

const COUNTS = 'true counts, including in progress';

/** True when the filter bar has a start or an end date set. */
export const datesChosen = (filters) => Boolean(filters && (filters.dateFrom || filters.dateTo));

/** Query params for GET /reports/mis/trend. `months` is only sent when no date range is set. */
export const trendRequestParams = (filters = {}, months = DEFAULT_TREND_MONTHS) =>
  datesChosen(filters) ? { ...filters } : { ...filters, months };

/** The line under the chart title, naming the window that is on screen. */
export const trendCaption = (filters, months) =>
  datesChosen(filters) ? `${COUNTS} · your date range` : `${COUNTS} · last ${months} months`;
